import React, { useEffect } from 'react';

/**
 * Modale du Planning annuel — même anatomie que celles de l'Administration
 * (en-tête coloré, corps, pied à droite), avec la couleur du module.
 *
 * La charte interdit `window.confirm` / `alert` / `prompt` : ce composant est le
 * seul chemin du module.
 *
 * ── POURQUOI CE FICHIER EXISTE (lot 5.4 bis) ──────────────────────────────────
 * Il était défini au bas de `PlanningApp.js`, sans être exporté. Résultat : le
 * Paramétrage a réécrit à la main le même balisage pour sa modale de garde-fou, et
 * le référentiel des événements allait en écrire un troisième exemplaire. Trois
 * copies d'une même modale, c'est trois occasions de diverger — le lot 5.4 a fait
 * exactement le même geste avec la topbar, qui était inlinée deux fois.
 *
 * `taille="lg"` reprend la variante `.pl-modal.lg` déjà présente dans la feuille de
 * style (utilisée par le récapitulatif de suppression du Paramétrage).
 */
function ModalePlanning({ titre, icone, children, pied, onFermer, taille }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onFermer(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onFermer]);

    return (
        <div className="pl-modal-overlay" onClick={onFermer}>
            <div
                className={'pl-modal' + (taille === 'lg' ? ' lg' : '')}
                onClick={e => e.stopPropagation()}
            >
                <div className="pl-modal-h">
                    <i className={'fa-solid ' + (icone || 'fa-circle-info')} />
                    {titre}
                    <button className="x" onClick={onFermer} aria-label="Fermer">&times;</button>
                </div>
                <div className="pl-modal-b">{children}</div>
                <div className="pl-modal-f">{pied}</div>
            </div>
        </div>
    );
}

export default ModalePlanning;
